const STATUS_CONFIG = {
  ACTIVE: {
    label: 'Active',
    dot: 'bg-green animate-pulse',
    text: 'text-green',
    border: 'border-green',
    bg: 'bg-green-faint',
  },
  PAUSED: {
    label: 'Paused',
    dot: 'bg-yellow',
    text: 'text-yellow',
    border: 'border-yellow',
    bg: 'bg-yellow-faint',
  },
  TERMINATED: {
    label: 'Terminated',
    dot: 'bg-red',
    text: 'text-red',
    border: 'border-red',
    bg: 'bg-red-faint',
  },
  PENDING: {
    label: 'Pending',
    dot: 'bg-text-dim animate-pulse',
    text: 'text-text-dim',
    border: 'border-border-bright',
    bg: 'bg-surface2',
  },
  EVALUATING: {
    label: 'Evaluating',
    dot: 'bg-indigo animate-pulse',
    text: 'text-indigo',
    border: 'border-indigo',
    bg: 'bg-indigo-faint',
  },
  PASSED: {
    label: 'Passed',
    dot: 'bg-green',
    text: 'text-green',
    border: 'border-green',
    bg: 'bg-green-faint',
  },
  FAILED: {
    label: 'Failed',
    dot: 'bg-red',
    text: 'text-red',
    border: 'border-red',
    bg: 'bg-red-faint',
  },
  ROLLED_BACK: {
    label: 'Rolled back',
    dot: 'bg-yellow',
    text: 'text-yellow',
    border: 'border-yellow',
    bg: 'bg-yellow-faint',
  },
}

const FALLBACK = {
  label: 'Unknown',
  dot: 'bg-text-faint',
  text: 'text-text-faint',
  border: 'border-border',
  bg: 'bg-surface',
}

export default function StatusBadge({ status, size = 'sm' }) {
  const config = STATUS_CONFIG[status] ?? FALLBACK

  const sizeClasses =
    size === 'xs'
      ? 'text-2xs px-1.5 py-0.5 gap-1'
      : 'text-xs px-2 py-1 gap-1.5'

  return (
    <span
      className={`inline-flex items-center rounded font-mono font-medium border ${sizeClasses} ${config.text} ${config.border} ${config.bg}`}
      aria-label={`Status: ${config.label}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} aria-hidden="true" />
      {config.label}
    </span>
  )
}
